import { cn } from '@/lib/utils';

interface CaldeiraIconProps {
  className?: string;
}

export const CaldeiraIcon = ({ className }: CaldeiraIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="100 100 300 300"
    className={cn('w-4 h-4', className)}
    fill="#00E63A"
  >
    <path d="M 100 400 L 100 100 L 200 100 L 200 200 L 300 200 L 300 300 L 400 300 L 400 400 L 100 400 Z" />
  </svg>
);
